import { render, staticRenderFns } from "./WaveIcon.vue?vue&type=template&id=1efef678"
import script from "./WaveIcon.vue?vue&type=script&lang=js"
export * from "./WaveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports